import { useQuery } from '@tanstack/react-query';
import { getHistoricalData } from '../historical-data';
import { HistoricalDataParams } from '../historical-data/types';

export function useHistoricalData(params: HistoricalDataParams) {
  // Create a more specific query key that includes the date range
  // This ensures React Query properly invalidates the cache when the date changes
  return useQuery({
    queryKey: ['historical-data', params.device_id, params.datapoints, params.start_timestamp, params.end_timestamp],
    queryFn: () => getHistoricalData(params),
    staleTime: 300000, // Consider data fresh for 5 minutes
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
